var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maxLayout"},[(_vm.loading)?_c('div',{staticClass:"loading vh-100"},[_c('img',{attrs:{"src":"img/Dual Ring-1s-87px.gif","alt":"loading"}})]):_c('div',[_c('Header'),_c('router-view'),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }